module.exports = {"TXTCLI_Available":{"id":"TXTCLI_Available","defaultMessage":"可用餘額"},"TXTCLI_Expires":{"id":"TXTCLI_Expires","defaultMessage":"到期"}}